export default __webpack_public_path__ + "static/media/dollar.b1ad1fa2.svg";